// extracted by mini-css-extract-plugin
export default {"text":"V6Buvv","sortWrapper":"cjB6Ie","mobile":"rbE8gj"};